import { Button } from 'app/shared/components/Button/Button';
import { Container } from '../Container/Container';
import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';

interface Props {
  showInfo: boolean;
  type: string;
}

export const BannerSt = styled.div<Props>`
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  left: 0;
  background-color: ${({ type, theme, color }) =>
    type === 'success'
      ? theme.colors[color || 'primary']
      : theme.colors.error500};

  ${media.sm(css`
    top: 2rem;
    right: 4rem;
    width: 30rem;
    left: unset;
  `)};
  transition: ${({ showInfo }: Props) =>
    showInfo ? 'transform 0.4s' : 'none'};
  transform: ${({ showInfo }: Props) =>
    showInfo ? 'translateY(0)' : 'translateY(-100px)'};
  -webkit-transform: ${({ showInfo }: Props) =>
    showInfo ? 'translateY(0)' : 'translateY(-100px)'};
`;

export const CtaButtonSt = styled(Button).attrs(() => ({
  type: 'button',
  fullSize: true,
}))``;

export const ContainerSt = styled(Container)<Props>`
  display: flex;
  align-items: center;
  padding: 0 2rem;
  height: 3.5rem;
`;

export const TextSt = styled(Container)`
  font-weight: bold;
  flex: 1;
  color: ${({ theme }) => theme.colors.black};
`;
